export type HelpPageKey =
  | 'DASHBOARD'
  | 'PROJECTS'
  | 'COLLECTIONS'
  | 'ENVIRONMENTS'
  | 'FUNCTIONS'
  | 'SWAGGER'
  | 'MANAGE_ACCOUNT'
  | 'AI_AGENT';

interface HelpPageContext {
  moduleId: string;
  subModuleId?: string;
  helpPath: string;
}

const HELP_PAGE_CONTEXT: Record<HelpPageKey, HelpPageContext> = {
  DASHBOARD: {
    moduleId: 'getting-started',
    subModuleId: 'getting-started-overview',
    helpPath: '/help?module=getting-started&subModule=getting-started-overview',
  },
  PROJECTS: {
    moduleId: 'projects',
    subModuleId: 'projects-managing',
    helpPath: '/help?module=projects&subModule=projects-managing',
  },
  COLLECTIONS: {
    moduleId: 'collections-requests',
    subModuleId: 'collections-overview',
    helpPath: '/help?module=collections-requests&subModule=collections-overview',
  },
  ENVIRONMENTS: {
    moduleId: 'collections-requests',
    subModuleId: 'requests-configuring',
    helpPath: '/help?module=collections-requests&subModule=requests-configuring',
  },
  FUNCTIONS: {
    moduleId: 'functions',
    subModuleId: 'functions-overview',
    helpPath: '/help?module=functions&subModule=functions-overview',
  },
  SWAGGER: {
    moduleId: 'swagger',
    subModuleId: 'swagger-importing',
    helpPath: '/help?module=swagger&subModule=swagger-importing',
  },
  MANAGE_ACCOUNT: {
    moduleId: 'manage-account',
    subModuleId: 'manage-account-overview',
    helpPath: '/help?module=manage-account&subModule=manage-account-overview',
  },
  AI_AGENT: {
    moduleId: 'ai-agent',
    subModuleId: 'ai-agent-features',
    helpPath:
      '/help?module=ai-agent&subModule=ai-agent-features&article=ai-agent-features-overview-all',
  },
};

export const getHelpPathForPage = (key: HelpPageKey): string => HELP_PAGE_CONTEXT[key].helpPath;

export const getHelpContextForPage = (key: HelpPageKey): HelpPageContext => HELP_PAGE_CONTEXT[key];

